import { useEffect } from 'react';
import AuthService from '../services/auth.service';

export default function ExtLogin() {
  const authService = AuthService.getInstance();

  useEffect(() => {
    if (authService.isCustomDomain && authService.returnToken) {
      // Custom domain — redirect to the main app for login, passing signed returnTo
      const returnTo = encodeURIComponent(window.location.origin);
      const token = encodeURIComponent(authService.returnToken);
      window.location.href = `${authService.authAppUrl}/login?returnTo=${returnTo}&returnToken=${token}`;
    } else if (authService.isCustomDomain) {
      // Custom domain without a signed token — redirect to main app login without returnTo
      window.location.href = `${authService.authAppUrl}/login`;
    } else {
      // Redirect to the legacy app for login (used locally where Frontegg OAuth
      // is configured for a different port)
      window.location.href = `${authService.authAppUrl}/login`;
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}
